// DEPRECATED TYPE SCRIPTS
export const SCRIPT_TYPE_OUTBOUND = 'outbound';
export const SCRIPT_TYPE_INBOUND = 'inbound';
export const SCRIPT_TYPE_VERIFICATION = 'verification';
export const SCRIPT_TYPE_GENERAL = 'general';
